import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

import { SharedDataService } from '@teem/services/shared-data.service';
import { ExpenseService } from '@teem/services/expense.service';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { environment } from '@teem/environments/environment';
import { PLAN_TYPES } from '@teem/constants/subscription';
import { EXPENSE_TYPES } from '@teem/constants/expenses';
import { parseDate } from '@teem/helpers/functions';

import { ExpensesTableComponent } from '@teem/expenses-module/components/expenses-table/expenses-table.component';
import { AddExpenseModalComponent } from '@teem/expenses-module/modals/add-expense-modal/add-expense-modal.component';

declare var $;
@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styles: []
})
export class ExpensesComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @ViewChild('expensesTableRef') expensesTableRef: ExpensesTableComponent;

  activeTab: string = 'all';
  invoices: Array<any>;
  isSearch: boolean = false;
  totalSum: number = 0;
  userInfo: any;
  isFilter: boolean = false;
  fromDate: any = '';
  toDate: any = '';
  minAmount: any;
  maxAmount: any;
  subjectToVat: any = '';
  params: any = {};
  expenseTypes: Array<object> = EXPENSE_TYPES;
  filterTypes: any;
  routeSubscriber: any;

  constructor(
    private modalService: NgbModal,
    private expenseService: ExpenseService,
    private sharedDataService: SharedDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loadCommonData();
    this.routeSubscriber = this.route.queryParams.subscribe(params => {
      if (params && params['create-tax']) {
        this.openAddExpenseModal()
      }
    });

    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;
      }
    });

    if (this.activeTab == 'all') {
      this.filterTypes = this.expenseTypes;
    }
  }

  loadCommonData() {
    this.expenseService.commonData().subscribe((data: any) => {
      this.totalSum = data.total;
      this.invoices = data.invoices;
    })
  }

  ngOnDestroy() {
    this.routeSubscriber.unsubscribe();
  }

  ngAfterViewInit(){
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 100);
  }

  openAddExpenseModal() {

    const modalRef = this.modalService.open(AddExpenseModalComponent);
    // // Set id on modal dialog
    modalRef.componentInstance.isProPlan = this.isProPlan();
    modalRef.componentInstance.invoicesList = this.invoices;
    modalRef.componentInstance.expenseTypes = this.expenseTypes;
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "newexpenses";

    modalRef.result.then(result => {
      this.expensesTableRef.getPage(1);
      // Trigger change event in parent component
      this.onChangeExpense(true);
    }, fallbackResult => {

    })
  }
  toggleFilter() {
    this.isFilter = !this.isFilter;
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetVatFilters();
    this.subjectToVat = "";
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 100);

  }

  filterByDate() {
    if (this.fromDate) {
      this.params.from_date = this.fromDate;//parseDate(this.fromDate);
    }
    if (this.toDate) {
      this.params.to_date = this.toDate;//parseDate(this.toDate);
    }

    if (!(this.params.from_date || this.params.to_date)) {
      // On clear button click - Because we can't reset date filter individually for each table so here reload all tables when clear btn clicked.
      this.expensesTableRef.resetDateFilters();
      this.expensesTableRef.getPage(1);

    } else if (this.params.from_date && this.params.to_date) {

      this.expensesTableRef.getPage(1, false, this.params);
    }
  }

  @ngDebounce(500)
  filterByAmount() {
    this.params.min_amount = (this.minAmount) ? this.minAmount : '';
    this.params.max_amount = (this.maxAmount) ? this.maxAmount : '';

    if (!(this.params.min_amount || this.params.max_amount)) {
      this.expensesTableRef.resetDateFilters();
      this.expensesTableRef.getPage(1);
    } else if (this.params.min_amount || this.params.max_amount) {
      this.expensesTableRef.getPage(1, false, this.params);
    }
  }

  resetDateFilters() {
    if (this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }
  }

  resetAmountFilters() {
    if (this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }
  }

  resetVatFilters() {
    if (this.subjectToVat) {
      this.subjectToVat = "";
      this.filterExpenses();
    }
  }

  onChangeExpense(value?: any) {
    this.loadCommonData();
  }

  isProPlan() {
    return this.userInfo && this.userInfo.subscription && this.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
  }

  switchTab(tab: string) {
    this.activeTab = tab;
    if (tab == 'all') {
      this.filterTypes = this.expenseTypes;
    } else {
			this.expensesTableRef.timeFilter = '';
      this.filterTypes = this.expenseTypes.filter(function (type: any) {
        return (type.value == tab) ? type : null;
      });
    }

    if (this.activeTab) {
      this.params.category = this.activeTab;
    }

    if (this.params.category) {
      this.expensesTableRef.categoryFilter = this.params.category;
      this.expensesTableRef.getPage(1, true, this.params);
    }
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchExpenses("");
    }
  }

  filterExpenses() {
    this.expensesTableRef.timeFilter = this.subjectToVat;
    this.expensesTableRef.getPage(1);
  }

  searchExpenses(term: string) {
    this.expensesTableRef.search.next(term);
  }

  exportXls() {
    (window as any).open(`${environment.baseUrl}/expenses/download?from=${this.fromDate}&to=${this.toDate}&filter_by=${this.subjectToVat}&type=${this.activeTab}`, '_self', 'location=yes');
  }

  clearAllFilter() {
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetVatFilters();
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  onChangePerPageItems(page: any) {
    if (page?.limit) {
      this.params.limit = page?.limit;
      this.expensesTableRef.getPage(1, false, this.params);
    }
  }
}
